import cx from 'classnames';
import { ComponentProps, forwardRef, useEffect } from 'react';
import styles from './RichText.module.scss';

type RichTextProps = ComponentProps<'div'> & {
	content: string;
};
export const RichText: React.FC<RichTextProps> = forwardRef(({ content, className }, ref) => {
	useEffect(() => {
		// wrapping RTE table inside an element to create scroll
		const rteTable = document.querySelectorAll('.RichText table');
		rteTable.forEach((el) => {
			const wrapper = document.createElement('aside');
			wrapper.style.overflowX = 'auto';
			// insert wrapper before el in the DOM tree
			el.parentNode.insertBefore(wrapper, el);
			// move el into wrapper
			wrapper.appendChild(el);
		});

		// wrap contents in a <li> with <div></div> for flex display
		const allListItems = document.querySelectorAll('.RichText ol li');
		allListItems?.forEach((el) => {
			const div = document.createElement('div');
			div.innerHTML = el.innerHTML;
			el.innerHTML = '';
			el.appendChild(div);
		});
	}, [content]);

	return <div ref={ref} className={cx(styles.RichText, className)} dangerouslySetInnerHTML={{ __html: content }} />;
});
RichText.displayName = 'RichText';
